export const CUSTOMER_PORTAL_BASE_PATH = "/customer-portal";
export const customerPortalPath = (path = "") => `${CUSTOMER_PORTAL_BASE_PATH}${path ? `/${path.replace(/^\/+/, "")}` : ""}`;
